import { graphql } from '../graphql';

// Query for organization subscription info (included in organization query)
export const organizationWithSubscriptionQuery = graphql(`
  query OrganizationWithSubscription($id: ID!) {
    organization(id: $id) {
      id
      name
      storageUsedBytes
      storageLimitBytes
      subscription {
        tier
        billingStatus
        collectionMethod
        billingInterval
        storageBlocks
        storageLimitBytes
        currentPeriodEnd
        cancelAtPeriodEnd
        cancelAt
        scheduledTier
        scheduledStorageBlocks
        scheduledChangeAt
        trialEndsAt
      }
    }
  }
`);

// Query for detailed subscription information including invoices
export const subscriptionDetailsQuery = graphql(`
  query SubscriptionDetails($organizationId: ID!) {
    subscriptionDetails(organizationId: $organizationId) {
      info {
        tier
        billingStatus
        collectionMethod
        billingInterval
        storageBlocks
        storageLimitBytes
        currentPeriodEnd
        cancelAtPeriodEnd
        cancelAt
        scheduledTier
        scheduledStorageBlocks
        scheduledChangeAt
        trialEndsAt
      }
      invoices {
        id
        number
        status
        amountDue
        amountPaid
        currency
        created
        dueDate
        hostedInvoiceUrl
        pdfUrl
      }
      nextInvoicePreview {
        amountDue
        currency
        periodStart
        periodEnd
        lines {
          description
          amount
          quantity
        }
      }
      discount {
        promoCodeId
        couponId
        name
        percentOff
        amountOff
        expiresAt
      }
    }
  }
`);

// Query for validating promo codes
export const validatePromoCodeQuery = graphql(`
  query ValidatePromoCode($code: String!) {
    validatePromoCode(code: $code) {
      valid
      name
      percentOff
      amountOff
    }
  }
`);

// Query for subscription pricing (graduated tiers)
export const subscriptionPricingQuery = graphql(`
  query SubscriptionPricing {
    subscriptionPricing {
      currency
      tiers {
        tier
        name
        description
        storage {
          monthly {
            upTo
            unitAmount
            unitAmountDecimal
          }
          annual {
            upTo
            unitAmount
            unitAmountDecimal
          }
        }
      }
    }
  }
`);
